import React from 'react';
import {
    bankCounterpartyLabel, bankPaymentMessage, bankSecondaryFacts, bankTextSourceLabel, bankTransactionLabel,
} from '../../../utils/bankTransactionText';

const MISSING = 'Saknas i bankunderlaget';

/**
 * The transaction as the bank describes it. The headline is the best label
 * the backend resolved (recipient → merchant/message → type); the facts
 * under it always mean the same thing regardless of import path.
 *
 *  - default: drawer — headline + every labelled fact, missing ones said so,
 *    with the import that supplied each (this is where facts are read).
 *  - summary: booking modal — headline + only the facts that add something.
 */
export default function BankTransactionFacts({ line, variant = 'full' }) {
    const headline = bankTransactionLabel(line) || '(ingen beskrivning)';

    if (variant === 'summary') {
        const facts = bankSecondaryFacts(line);
        return (
            <div>
                <div style={{ fontSize: '0.875rem', fontWeight: 500, color: '#1f2937', overflowWrap: 'anywhere' }}>{headline}</div>
                {facts.length > 0 && (
                    <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>
                        {facts.map(fact => `${fact.label}: ${fact.value}`).join(' · ')}
                    </div>
                )}
            </div>
        );
    }

    const fields = [
        { label: 'Meddelande', value: bankPaymentMessage(line), source: line.text_sources?.payment_message },
        { label: bankCounterpartyLabel(line), value: line.counterparty_name, source: line.text_sources?.counterparty_name },
        { label: 'Transaktionstyp', value: line.transaction_type, source: line.text_sources?.transaction_type },
    ];
    return (
        <div>
            <div style={{ fontSize: '0.9375rem', fontWeight: 600, color: '#111827', overflowWrap: 'anywhere' }}>{headline}</div>
            <dl style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 20px', margin: '6px 0 0', fontSize: 13, color: '#6b7280' }}>
                {fields.map(({ label, value, source }) => (
                    <div key={label} style={{ minWidth: 0, overflowWrap: 'anywhere' }}>
                        <dt style={{ display: 'inline', fontWeight: 500 }}>{label}: </dt>
                        <dd style={{ display: 'inline', margin: 0 }}>
                            {value || MISSING}
                            {value && bankTextSourceLabel(source) && (
                                <span style={{ fontSize: 11 }}> ({bankTextSourceLabel(source)})</span>
                            )}
                        </dd>
                    </div>
                ))}
            </dl>
        </div>
    );
}
